import { abortableFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export const deleteNotificationApiCall = (id: string) =>
  abortableFetch(`${EvidenceApiUrl.NOTIFICATION_RECEIVED}/${id}`, {
    method: 'DELETE',
  });
